// FLAGS: identity, legacy
// The `/authorized` landing page for an external (Google) authorization redirect. It is dead: the method
// it calls no longer exists on the authentication service, so mounting this route throws. Do not model
// new identity code on it — the live login path is views/Login/.
import { PureComponent } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import authenticationService from "@src/services/authentication.service";
import { timeSnackbar } from "@src/constants";
import { withSnackbar } from "@src/components/SnackBarComponent";

class AuthorizedExternalView extends PureComponent {
  // FLAGS: identity, legacy
  // `authenticationService.getExternalUser` is not part of the service's exported object, so this line
  // raises a TypeError the moment the route mounts and the whole app falls to the top-level error
  // boundary. The failure branch below would not have helped either: it calls `props.snackbarShowMessage`
  // on a bare `props` that does not exist in this class scope. Restoring this route means restoring a
  // service method and reaching it through `this.props`, not editing around the symptom.
  componentDidMount() {
    const { navigate } = this.props;

    authenticationService
      .getExternalUser()
      .then(() => {
        this.props.snackbarShowMessage("Success", "success");
        setTimeout(() => {
          navigate("/login");
        }, timeSnackbar);
      })
      .catch((error) => {
        props.snackbarShowMessage(error.response, "error");
      });
  }

  render() {
    return null;
  }
}

AuthorizedExternalView.propTypes = {
  navigate: PropTypes.func.isRequired,
};
const WrappedAuthorizedExternalView = (props) => {
  const navigate = useNavigate();

  return <AuthorizedExternalView {...props} navigate={navigate} />;
};

export default withSnackbar(WrappedAuthorizedExternalView);
